// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "WorkingHours-module--wrapper--pfhpw";
export var title = "WorkingHours-module--title--0G7QD";
export var bolder = "WorkingHours-module--bolder--7bjjl";
export var transparentBg = "WorkingHours-module--transparentBg--e6p++";